import React from 'react';
import { Target } from 'lucide-react';
import ModulePage from './ModulePage';

const scanChecks = (w, input) => [
  { label: 'Google Ads actief', passed: !!input.heeft_advertenties, detail: input.heeft_advertenties ? 'Advertenties lopen' : 'Geen advertenties — concurrenten pakken uw klanten' },
  { label: 'Analytics voor ads', passed: !!input.heeft_analytics, detail: input.heeft_analytics ? 'Conversie tracking mogelijk' : 'Geen analytics — geen inzicht in advertentie resultaten' },
];

export default function AdvertentiesPage() {
  return (
    <ModulePage
      category="advertenties"
      title="Advertenties"
      subtitle="Google Ads en online adverteren"
      icon={Target}
      color="#ef4444"
      scanChecks={scanChecks}
    />
  );
}
